import Configs from "../configs";

const { BACKEND_URL, IS_LOCAL, IS_DEVELOPMENT, X_AMBASADOR_USERNAME, X_AMBASADOR_PASSWORD } = Configs;

const BASE_URL = `${BACKEND_URL}/fees`

const headers: { [key: string]: string } = {
    "Content-Type": "application/json",
}

if (IS_LOCAL || IS_DEVELOPMENT) {
    headers["x-ambassador-username"] = X_AMBASADOR_USERNAME;
    headers["x-ambassador-password"] = X_AMBASADOR_PASSWORD;
}

export type GetFeesRequestProps = {
    language?: string | null;
    currency?: string | null;
    searchText?: string | null;
    validAt?: string | null;
    feeGroupCode?: string | null;
    feeCode?: string | null;
}

const getFees = (params: GetFeesRequestProps) => {

    const queryParams = new URLSearchParams();

    if (params.language) queryParams.append('language', params.language);
    if (params.currency) queryParams.append('currency', params.currency);
    if (params.validAt) queryParams.append('validAt', params.validAt);
    if (params.feeCode) queryParams.append('feeCode', params.feeCode);
    if (params.feeGroupCode) queryParams.append('feeGroupCode', params.feeGroupCode);

    let url = `${BASE_URL}?${queryParams.toString()}`;

    if (params.searchText) url += `&searchText=${params.searchText}`

    return fetch(url, {
        method: "GET",
        headers: headers
    });
}

export type GetFeeDetailsRequestProps = {
    feeCode: string;
    currency?: string;
    language?: string;
}

const getFeeDetails = (params: GetFeeDetailsRequestProps) => {

    const queryParams = new URLSearchParams();

    if (params.language) queryParams.append('language', params.language);
    if (params.currency) queryParams.append('currency', params.currency);

    const url = `${BASE_URL}/${params.feeCode}/details?${queryParams.toString()}`;

    return fetch(url, {
        method: "GET",
        headers: headers,
    });
}

type GetFeeGroupsRequestProps = {
    language?: string;
}

const getFeeGroups = (params: GetFeeGroupsRequestProps) => {

    const queryParams = new URLSearchParams();

    if (params.language) queryParams.append('language', params.language);

    const url = `${BASE_URL}/feegroups?${queryParams.toString()}`;

    return fetch(url, {
        method: "GET",
        headers: headers,
    });
}

export const feesApi = {
    getFees,
    getFeeDetails,
    getFeeGroups
}